export const AGREEMENTS = '/agreements'
export const EARNINGS_REPORT = '/earnings-report'
export const QUARTERLY_STATEMENTS = '/quarterly-royalties-statements'
export const EDIT_FOUNDRY = '/edit-foundry/:id'
export const EDIT_PROMOTION = '/promos/edit-promo/:id'
export const ERROR_400 = '/400'
export const ERROR_403 = '/403'
export const ERROR_404 = '/404'
export const ERROR_412 = '/412'
export const ERROR_500 = '/500'
export const ERROR_503 = '/503'
export const FOUNDRY_PROFILE = '/foundry-profile'
export const HOME = '/manage-fonts'
export const LOGIN = '/login'
export const LOGOUT = '/logout'
export const USER_PROFILE = '/user-profile'
export const PROMOTION_DASHBOARD = '/promos'
export const NEW_PROMOTION = '/promos/new-promo'
export const PAYMENT_DASHBOARD = '/payments'
export const PAYMENT_ACCOUNTS = '/payment-accounts'
export const PAYMENT_ACCOUNTS_NEW_MANAGE = '/payment-accounts/:id/manage'
export const PAYMENT_ACCOUNTS_EDIT_MANAGE = '/payment-accounts/:id/edit'
export const PROMOTION_SUCCESS = '/promos/success'
export const VIEW_PROMOTION = '/view-promo/:id'
export const USER_PERMISSIONS = '/user-permissions'
export const BULK_IMPORT = '/bulk-import'
export const ERROR_424 = '/424'
export const PAYMENTS = '/payments'
export const PAYMENT_ACCOUNT = '/payment-accounts'
export const AGGREMENTS = '/agreements'
export const DASHBOARD = '/dashboard'
export const VERIFY_EMAIL = '/verify-email'
export const NON_UFDA2 = '/non-ufda2/:id'
export const INVENTORY_INGESTION_HUB = '/inventory-hub'
export const INVENTORY_INGESTION_CREATE = '/create-inventory-ingestion/:id'
export const FOUNDRY_APPLICATIONS = '/applications'
export const MFP_NUMBERS = '/mfp-numbers'
export const UPLOAD_FLIP_FONTS = '/create-dropship/:id'
export const DROPSHIP = '/dropship'
export const QUARTERLY_EARNINGS_UPLOAD = '/quarterly-earnings-upload'
export const REACTIVATE_FONT_FAMILIES = '/reactivate-font-families/:foundryId'
